import { type LatLng } from '../model'

export function closePolygon(coordinates: LatLng[]): LatLng[] {
  if (coordinates.length < 3) return coordinates
  const first = coordinates[0]
  const last = coordinates.at(-1)
  if (isLatLngEqual(first, last)) return coordinates
  return [...coordinates, first]
}

function isLatLngEqual(a: LatLng, b?: LatLng): boolean {
  if (!b) return false
  return a.latitude === b.latitude && a.longitude === b.longitude
}

export function toGeoJSONCoordinates(coordinates: LatLng[]): [number, number][] {
  return coordinates.map(({ latitude, longitude }) => [longitude, latitude])
}
